// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCWcz2feE6sQ28B7-ZEpykAjoRS_pv5cOs",
  authDomain: "movie-website-b5860.firebaseapp.com",
  projectId: "movie-website-b5860",
  storageBucket: "movie-website-b5860.appspot.com",
  messagingSenderId: "955959782468",
  appId: "1:955959782468:web:4fda0e074c52293951e011",
  measurementId: "G-BLYX7LLLYY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);

export { db }; 